import axios from "axios";
import ErrorMessage from "../libs/helpers/ErrorMessage";
import Config from "../Config";
import { getFromLocalStorage } from "../libs/helpers/localstorage";

export const getPitchGraphApi = async ({ headers, data }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  try {
    const res = await axios.post(
      `${Config.apiBaseurl}/${Config.apis.frontend.api}/pitch/graph`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant": tenant,
          ...headers,
        },
      },
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};

export const getPitchScoresApi = async ({ headers, data = {} }) => {
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const ls = getFromLocalStorage();
  const token = ls && ls.token;
  try {
    const res = await axios.post(
      `${Config.apiBaseurl}/api/v1/pitch/scores`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant": tenant,
          ...headers,
        },
      },
    );

    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    } else throw e;
  }
};
